module.exports = __webpack_public_path__ + "img/garden-after.b81bb6e9.jpg";